/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfIEnumerableOfRegistrationKeyDto } from '../../models/platform-api-result-of-i-enumerable-of-registration-key-dto';

export interface GetUseraccountsRegistrationKeys$Params {
}

export function getUseraccountsRegistrationKeys(http: HttpClient, rootUrl: string, params?: GetUseraccountsRegistrationKeys$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfIEnumerableOfRegistrationKeyDto>> {
  const rb = new RequestBuilder(rootUrl, getUseraccountsRegistrationKeys.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfIEnumerableOfRegistrationKeyDto>;
    })
  );
}

getUseraccountsRegistrationKeys.PATH = '/api/useraccounts/registration-keys';
